import type { ContactInfo, SocialLink } from '../types/contact'

export const contactInfo: ContactInfo = {
  email: 'abrahammgag@gmail.com',
  location: 'Addis Ababa, Ethiopia',
  availability: 'Open to New Opportunities',
  timezone: 'EAT (UTC+3)'
}

export const socialLinks: SocialLink[] = [
  {
    name: 'GitHub',
    url: 'https://github.com/Abmichael',
    icon: 'github',
    color: 'text-gray-800',
    hoverColor: 'hover:text-gray-900'
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/abrahammgag/',
    icon: 'linkedin',
    color: 'text-blue-600',
    hoverColor: 'hover:text-blue-700'
  },
  {
    name: 'Email',
    url: 'mailto:abrahammgag@gmail.com',
    icon: 'email',
    color: 'text-green-600',
    hoverColor: 'hover:text-green-700'
  },
  {
    name: 'Twitter',
    url: 'https://x.com/abrahammgag',
    icon: 'twitter',
    color: 'text-blue-400',
    hoverColor: 'hover:text-blue-500'
  }
]

// Contact reasons for form subject suggestions
export const contactReasons = [
  'General Inquiry',
  'Project Collaboration',
  'Job Opportunity',
  'Freelance Work',
  'Technical Consultation',
  'Startup Partnership',
  'Open Source Contribution',
  'Other'
]

// FAQ items
export const faqItems = [
  {
    question: 'What type of projects do you work on?',
    answer: 'I specialize in full-stack web systems and cross-platform mobile apps, particularly in healthcare, logistics, transportation, and hospitality domains. I work with Vue 3, NestJS, Flutter, React Native (Expo), Node.js, and MongoDB/PostgreSQL.'
  },
  {
    question: 'Are you available for remote or freelance work?',
    answer: 'Yes, I am available for remote software engineering roles, mobile development, and technical consultation.'
  },
  {
    question: 'What is your typical response time?',
    answer: 'I aim to respond to all inquiries within 24-48 hours. Feel free to reach out via email at abrahammgag@gmail.com.'
  },
  {
    question: 'Do you offer technical architecture and consulting services?',
    answer: 'Yes! As co-founder & lead software engineer at Neo Technologies, I provide end-to-end software architecture design, cloud deployment setup (Docker, Nginx, CI/CD), and full-stack development.'
  }
]
